import {Component, inject, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxFormComponent
} from 'devextreme-angular';
import {
    DxiButtonComponent,
    DxiColumnComponent, DxiItemComponent, DxoColumnChooserComponent, DxoExportComponent, DxoFilterRowComponent,
    DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent,
    DxoPagingComponent, DxoScrollingComponent, DxoSortingComponent,
    DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {RoleGridViewDto, RolesClient, CreateRoleCommand} from '@services';
import notify from "devextreme/ui/notify";
import {FormPopupComponent} from "../../../components";
import {AddRoleFormComponent} from "./add-role-form/add-role-form.component";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {FilterConfig, GridPageComponent} from "../../common/grid-page.component";

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    imports: [
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxiButtonComponent,
        FormPopupComponent,
        AddRoleFormComponent,
        FilterPanelComponent,
        DxFormComponent
    ]
})
export class RolesComponent extends GridPageComponent<RoleGridViewDto> {
    @ViewChild(AddRoleFormComponent, {static: false}) createNewForm: AddRoleFormComponent;

    private rolesClient = inject(RolesClient);
    private router = inject(Router);

    isAddRolePopupOpened = false;
    roleId: string | undefined;
    dataSource = this.dataSources.roles();
    protected override exportName: string = "Roles";

    protected override filterConfig: FilterConfig[] = [
        { field: 'name', op: 'contains' },
        { field: 'description', op: 'contains' }
    ];

    constructor() {
        super();
        this.init(RoleGridViewDto);
        this.onDelete = this.onDelete.bind(this);
    }

    addRole() {
        this.isAddRolePopupOpened = true;
    };

    override async onRowDblClick(e: any) {
        const {data} = e;
        this.roleId = data.id;
        await this.router.navigate(['/role', this.roleId]);
    }

    onAddRolePopupSaveClick = () => {
        let formData = this.createNewForm.getData();

        let createCommand = new CreateRoleCommand({
            name: formData.name,
            description: formData.description
        });

        this.rolesClient.createRole(createCommand).subscribe({
            next: async () => {
                this.isAddRolePopupOpened = false;
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg => {
                    notify({
                        message: errMsg.message,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                }));
            }
        });
    }

    onDelete($event: any) {
        this.dataGrid.instance.deleteRow($event.row.dataIndex);
    }

    override onEdit = async (e: any) => {
        this.roleId = e.row.data.id;
        await this.router.navigate(['/role', this.roleId]);
    }
}
